
// 全局混入公共部分
export default {
    data() {
        return {
            page: 1,
            limit: 20,
            count: 0,
            uploadUrl: '',
            delTitle: '此操作会永久删除该选项，是否继续?'
        }
    },

    mounted() {
        this.uploadUrl = this.adminApi.upload_url;
    },

    methods: {
        /**
         * 下一页或者上一页方法， 这里约定， 所有查询列表的方法名叫getList
         */
        handleCurrentChange(currentPage) {
            this.page = currentPage;
            this.getList();
        },

        back() {
            this.$router.go(-1);
        }
    }
}


// WEBPACK FOOTER //
// ./static/js/before.js